import { MinusIcon, PlusIcon } from '@heroicons/react/24/solid'
import { useRef } from 'react'
import clsx from 'clsx'

const numberInputKeyDown = (event) => {
	const eventCode = event.code.toLowerCase()
	if (
		!(
			event.code !== null &&
			(eventCode.includes('digit') ||
				eventCode.includes('arrow') ||
				eventCode.includes('home') ||
				eventCode.includes('end') ||
				eventCode.includes('backspace') ||
				(eventCode.includes('numpad') && eventCode.length === 7))
		)
	) {
		event.preventDefault()
	}
}

const PricingTable = ({
	name,
	price,
	description,
	mostPopular,
	inputName,
	register,
	setValue,
	getValues,
	clearErrors,
	soldOut = false,
}) => {
	const countRef = useRef(null)

	return (
		<div
			className={clsx(
				'relative flex flex-col rounded-3xl p-8 transition-all duration-300',
				mostPopular && !soldOut
					? 'bg-gradient-to-br from-sage-50 to-sage-100/50 border-2 border-sage-300 shadow-warm-lg scale-[1.02]'
					: 'bg-white border border-sage-100 shadow-warm hover:shadow-warm-lg',
				soldOut && 'opacity-75',
			)}
		>
			{/* Recommended badge */}
			{mostPopular && !soldOut && (
				<div className='absolute -top-3 left-1/2 -translate-x-1/2'>
					<span className='inline-flex items-center rounded-full bg-harmoni-600 px-4 py-1.5 text-sm font-semibold text-white shadow-md'>
						Rekommenderas
					</span>
				</div>
			)}

			<div className='flex-1 text-center pt-2'>
				{/* Day name */}
				<h3 className='font-display text-2xl font-semibold text-sage-800 !m-0'>{name}</h3>

				{/* Price */}
				<p className='mt-4 flex items-baseline justify-center gap-1'>
					<span className='font-display text-5xl font-bold tracking-tight text-sage-900'>
						{price}
					</span>
					<span className='text-xl font-medium text-sage-900'>kr</span>
				</p>

				{/* Description */}
				<p className='mt-3 text-sage-900 text-base'>{description}</p>
			</div>

			{/* Quantity selector */}
			<div className='mt-6 flex justify-center'>
				<div className='inline-flex items-center rounded-2xl bg-sage-50 p-1'>
					<button
						type='button'
						disabled={soldOut}
						className={clsx(
							'flex h-12 w-12 items-center justify-center rounded-xl transition-all duration-200',
							soldOut
								? 'bg-sage-100 text-sage-300 cursor-not-allowed'
								: 'bg-white text-sage-600 shadow-sm hover:bg-sage-100 hover:text-sage-800 active:scale-95',
						)}
						onClick={() => {
							const current = getValues(inputName)
							if (current > 0) {
								setValue(inputName, current - 1)
							}
						}}
					>
						<MinusIcon className='h-5 w-5' aria-hidden='true' />
					</button>

					<div className='relative'>
						<input
							ref={countRef}
							disabled={soldOut}
							type='number'
							id={inputName}
							name={inputName}
							className={clsx(
								'block w-16 bg-transparent border-0 text-center text-xl font-semibold text-sage-800',
								'focus:ring-0 focus:outline-none !mb-0 !border-none',
								soldOut && 'text-sage-400',
							)}
							{...register(inputName, { min: 0, max: 99, valueAsNumber: true })}
							onChange={(e) => {
								let v = parseInt(e.target.value)
								if (v > 0) {
									clearErrors('saturday')
								}
								if (v > 99) {
									setValue(inputName, 99)
								} else if (v < 0 || isNaN(v)) {
									setValue(inputName, 0)
								}
							}}
							onKeyDown={numberInputKeyDown}
						/>
					</div>

					<button
						type='button'
						disabled={soldOut}
						className={clsx(
							'flex h-12 w-12 items-center justify-center rounded-xl transition-all duration-200',
							soldOut
								? 'bg-sage-100 text-sage-300 cursor-not-allowed'
								: 'bg-sage-500 text-white shadow-sm hover:bg-sage-600 active:scale-95',
						)}
						onClick={() => {
							const current = getValues(inputName)
							if (current < 99) {
								setValue(inputName, current + 1)
							}
						}}
					>
						<PlusIcon className='h-5 w-5' aria-hidden='true' />
					</button>
				</div>
			</div>

			{/* Sold out overlay */}
			{soldOut && (
				<div className='absolute inset-0 flex items-center justify-center'>
					<div className='bg-white/90 backdrop-blur-sm rounded-2xl px-6 py-3 shadow-warm-lg -rotate-6'>
						<span className='font-display text-2xl font-bold text-harmoni-600 tracking-wide'>
							SLUTSÅLT
						</span>
					</div>
				</div>
			)}
		</div>
	)
}

export default PricingTable
